// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3xyDs","arrowButton":"styles_arrowButton__1mymW","tableHeader":"styles_tableHeader__2dWT2","summary":"styles_summary__qCdUG"};